export const consumerIdStorageKey = "__cd_consumer_id";

declare global {
  interface Window {
    [consumerIdStorageKey]: string;
  }
}

export function getConsumerId() {
  let id: string | null = null;

  const getFromCookie = () => {
    const match = document.cookie.match(
      new RegExp(`(^| )${consumerIdStorageKey}=([^;]+)`)
    );
    return match ? match[2] : null;
  };

  const getFromLocalStorage = () => {
    return window.localStorage.getItem(consumerIdStorageKey);
  };

  const getFromSessionStorage = () => {
    return window.sessionStorage.getItem(consumerIdStorageKey);
  };

  id =
    getFromCookie() ||
    getFromLocalStorage() ||
    getFromSessionStorage() ||
    window[consumerIdStorageKey] ||
    crypto.randomUUID();

  try {
    document.cookie = `${consumerIdStorageKey}=${id}; path=/; max-age=${
      60 * 60 * 24 * 395
    }`;
    window.localStorage.setItem(consumerIdStorageKey, id);
    window.sessionStorage.setItem(consumerIdStorageKey, id);
    window["__cd_consumer_id"] = id;
  } catch {}

  return id;
}
